import { render, staticRenderFns } from "./IntroStepInfo.vue?vue&type=template&id=b16f58b2&scoped=true"
import script from "./IntroStepInfo.vue?vue&type=script&lang=js"
export * from "./IntroStepInfo.vue?vue&type=script&lang=js"
import style0 from "./IntroStepInfo.vue?vue&type=style&index=0&id=b16f58b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16f58b2",
  null
  
)

export default component.exports